import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import VueRouter from 'vue-router';
import moment from "moment"
import momentTimezone from "moment-timezone";
import Resource from 'vue-resource';
import router from './router'
import App from './App.vue'
import common from "./common.js";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

momentTimezone.tz.setDefault('Asia/Taipei');
Vue.use(Resource);
Vue.use(VueRouter, moment);
Vue.mixin(common);

// Expose SweetAlert2 globally for fallback shim
if (typeof window !== 'undefined') {
	window.Swal = Swal;
}

Vue.config.productionTip = false
Vue.http.options.root = '/api';

new Vue({
	router,
	render: h => h(App),
	data(){
		return{
			depts:["校安科", "輔導科", "衛生科", "學務科"]
		}
	}
}).$mount('#app')